import { emptyDataMustBuyValidation } from "../../features/manageCoupons/components/DefineCoupon/mustBuy/service";
import { generateRandomId } from "../../features/manageCoupons/services/services";
import { manageCouponInitialStateType } from "../../features/manageCoupons/types";
import { VALID } from "../../features/manageCoupons/utils/utils";
import store from "../store";

export function updateCouponTypeOptions(value: string) {
    store.dispatch({
        type: "updateCouponTypeOptions",
        payload: value
    })
}
export const updateActivePeriodCustomDates = (value: string[]) => {
    store.dispatch({
        type: "activePeriodCustomDates",
        payload: value,
    })
};


export const updateActivePeriodDays = (value: number[]) => {
    store.dispatch({
        type: "activePeriodDays",
        payload: value,
    })
};


export const updateActivePeriodWeeks = (value: number[]) => {
    store.dispatch({
        type: "activePeriodWeeks",
        payload: value
    })
};


export const updateActivePeriodMonths = (value: number[]) => {
    store.dispatch({
        type: "activePeriodMonths",
        payload: value
    })
};
export const updateisActivePeriodSaved = (value: boolean) => {
    store.dispatch({
        type: "isActivePeriodSaved",
        payload: value
    })
};
export const updateSavedCalendar = (value: string) => {
    store.dispatch({
        type: "savedCalendar",
        payload: value
    })
};


export const updateUsabilityLimit = (value: string|null) => {
    store.dispatch({
        type: "usabilityLimit",
        payload: value
    })
};
export const updateUsabilitySkip = (value: boolean) => {
    store.dispatch({
        type: "UpdateSkipUsability",
        payload: value
    })
};
export const updateNthOrderSkip = (value: boolean) => {
    store.dispatch({
        type: "UpdateSkipNthOrder",
        payload: value
    })
};
export const updateActivePeriodSkip = (value: boolean) => {
    store.dispatch({
        type: "UpdateSkipActivePeriod",
        payload: value
    })
};
export const updateCouponLifeSkip = (value: boolean) => {
    store.dispatch({
        type: "UpdateSkipCouponLife",
        payload: value
    })
};


// export function updateDateStartEnd(prop:string , value:any){
//     const {dateStartEnd} = store.getState().manageCoupons?.data?.recurrence?.dateStartEnd;

//     const newData = {...dateStartEnd , [prop]:value}
//     store.dispatch({
//         type:'updateDateStartEnd',
//         payload:newData
//     })

// }

export const updateDateStartEnd = (field: string, value: string) => {
    store.dispatch({
        type: 'updateDateStartEnd',
        payload: { field, value }
    })
};
  

export const updateUsability = (value: string|null) => {
    store.dispatch({
        type: "usability",
        payload: value
    })
};


export const updateOrderResetFrequency = (value: string) => {
    store.dispatch({
        type: "orderResetFrequency",
        payload: value
    })
};


export const updateNDaysFromActivation = (value: string) => {
    store.dispatch({
        type: "nDaysFromActivation",
        payload: value
    })
};


export const updateNumberOfPurchases = (value: string) => {
    store.dispatch({
        type: "numberOfPurchases",
        payload: value,
    })
};


export const updateCouponLife = (value: string|null) => {
    store.dispatch({
        type: "couponLife",
        payload: value,
    })
};


export function updateSchemeType(value:string){
    store.dispatch({
        type: "updateSchemeType",
        payload:value
    })
}
 

export function resetSchemeType(){
    store.dispatch({
        type: "resetSchemeType",
        payload:null
    })
}


export function resetCouponTypeOption(){
    store.dispatch({
        type: "resetCouponTypeOption",
        payload:null
    })
}
   

export function setEntites(data:Array<any>){
    store.dispatch({
        type:'setEntities',
        payload:data
    })
}


export function setALLPRODUCTS(data:Array<any>){
    store.dispatch({
        type:'setALLPRODUCTS',
        payload:data
    })
}


export function updateSchemeProductBifurcationsList(data:any,id?:string|null){
    const {schemeProductBifurcationsList} = store.getState().manageCoupons?.data;
    let newData = data;
    store.dispatch({
        type:'updateSchemeProductBifurcationsList',
        payload:[...schemeProductBifurcationsList,{...newData,id:generateRandomId()}]
    })


}
export function resetSchemeProductBifurcationsList(){
    store.dispatch({
        type: "resetSchemeProductBifurcationsList",
        payload:null
    })
}


export function deleteSchemeProductBifurcationsList(rowIndex:number){
    const {schemeProductBifurcationsList} = store.getState().manageCoupons?.data;
    const data = schemeProductBifurcationsList.filter((item:any,idx:number)=>idx!==rowIndex);
    store.dispatch({
        type:'updateSchemeProductBifurcationsList',
        payload:data
    })
}


export function deleteALLAndAddNewSchemeProductBifurcationsList(data:any){
    store.dispatch({
        type:'updateSchemeProductBifurcationsList',
        payload:[{...data,id:generateRandomId()}]
    })
}

export function addMustBuyData(data:any){
    const {data:mustBuy} = store.getState().manageCoupons?.data?.mustBuy;
    store.dispatch({
        type:'updateMustBuyData',
        payload:[...mustBuy,{...data,id:generateRandomId()}]
    })
}

export function deleteSingleMustBuyData(id:string , keyToDelete:string,tabsList:string[]){
    const {data:mustBuy} = store.getState().manageCoupons?.data?.mustBuy;

    const newData = mustBuy.map((item:any)=>{
        if(item.id === id){
            item[keyToDelete] = []
        }
        return item;
    }).filter((item:any)=>{
        // delete item whose all fields are empty array
        const res = emptyDataMustBuyValidation(item,tabsList);
        if(res === VALID) return item;
    })

    store.dispatch({
        type:'updateMustBuyData',
        payload:newData
    })
}

export function updateMustBuyData(data:any){
    store.dispatch({
        type:'updateMustBuyData',
        payload:[...data]
    })
}
export function updateMustBuyUnit(val:string){
    store.dispatch({
        type:'updateMustBuyQuantityUnit',
        payload:val
    })
}

export function updateMustBuyActive(value:boolean){
    store.dispatch({
        type:'updateMustBuyActive',
        payload:value
    })
}

export function resetSlabInfo(){
    store.dispatch({
        type: "resetSlabInfo",
        payload:null
    })
}

export function addApplicableSlab(data:any,id?:string){
    const {slabInfo} = store.getState().manageCoupons?.data;
    const slabs = slabInfo?.data;

    if(!id){
        store.dispatch({
            type:'updateSlabInfoData',
            payload:[{...data,id:generateRandomId(),isEdit:true},...slabs]
        })
    }else{
        // we are updating
        const newData = slabs.map((item:any)=>{
            if(item.id == id) return data;
            else return item;
        })
        store.dispatch({
            type:'updateSlabInfoData',
            payload:[...newData]
        })
    }
}

export function changeEditModeofSlab(slabId:string , value:boolean){
    const {data:slabs} = store.getState().manageCoupons?.data?.slabInfo;

    const newData = slabs.map((slab:any)=>{
        if(slab.id === slabId){
            return {
                ...slab,
                isEdit : value
            }
        }else return slab;
    })

    store.dispatch({
        type:'updateSlabInfoData',
        payload:newData
    })

}

export function deleteApplicableSlab(id:string){
    const {data:slabs} = store.getState().manageCoupons?.data?.slabInfo;

    const newData = slabs.filter((item:any)=>item.id !==id)
    store.dispatch({
        type:'updateSlabInfoData',
        payload:newData
    })
}

export function updateApplicableSlabUnit(val:string){
    store.dispatch({
        type:'updateSlabInfoUnit',
        payload:val
    })
}

export function updateSlabInfoQuantityUnit(val:string){
    store.dispatch({
        type: 'updateSlabInfoQuantityUnit',
        payload: val
    })
}

export function resetMustBuy(){
    store.dispatch({
        type: "resetMustBuy",
        payload:null
    })
}

export function addSchemeLocationBifurcationsList(data:any , id?:string | null){
    const {schemeLocationBifurcationsList} = store.getState().manageCoupons?.data;
    store.dispatch({
        type: 'updateSchemeLocationBifurcationsList',
        payload: [...schemeLocationBifurcationsList, { ...data }]
    })

}

export function deleteMarketFilter(index:number){
    const {schemeLocationBifurcationsList} = store.getState().manageCoupons?.data;
    const newData = schemeLocationBifurcationsList.filter((item:any,idx:number)=>idx!==index);
    store.dispatch({
        type:'updateSchemeLocationBifurcationsList',
        payload:newData
    })
}

export function deleteAllMarketFilters(){
    store.dispatch({
        type:'updateSchemeLocationBifurcationsList',
        payload:[]
    })
}


export function addSchemeOutletBifurcationsList(data:any , id?:string){
    const {schemeOutletBifurcationsList} = store.getState().manageCoupons?.data;
    store.dispatch({
        type: 'updateSchemeOutletBifurcationsList',
        payload: [...schemeOutletBifurcationsList, { ...data }]
    })

}


export function deleteOutletFilter(index:number){
    const {schemeOutletBifurcationsList} = store.getState().manageCoupons?.data;
    const newData = schemeOutletBifurcationsList.filter((item:any,idx:number)=>idx!==index);
    store.dispatch({
        type:'updateSchemeOutletBifurcationsList',
        payload:newData
    })
}

export function deleteAllOutletFilters(){
    store.dispatch({
        type:'updateSchemeOutletBifurcationsList',
        payload:[]
    })
}

export function updateSectionEnabled(value:object){
    store.dispatch({
        type:'updateSectionEnabled',
        payload:value
    })
}

export function switchPlaygroundMode(){
    const {isSchemePlayground} = store.getState().manageCoupons?.data;
    store.dispatch({
        type : "switchPlaygroundMode",
        payload : !isSchemePlayground
    })
}

export function reinitialiseCouponState(data : manageCouponInitialStateType ){
    store.dispatch({
        type : "reinitialiseCouponState",
        payload : data

    })}
 
export function updateSingleSectionEnabled(sectionName:string , val:boolean){
    const {sectionEnabled} = store.getState().manageCoupons?.data;
    const newVal = {...sectionEnabled , [sectionName]:val};
    store.dispatch({
        type:"updateSectionEnabled",
        payload:newVal
    })
}

export function resetSectionEnabled(){
    store.dispatch({
        type:'resetSectionEnabled',
        payload:null
    })
}
export function updateUsabilityLimits(prop:string , value:any){
    const {usabilityLimits} = store.getState().manageCoupons?.data;

    const newData = {...usabilityLimits , [prop]:value}
    store.dispatch({
        type:'updateUsabilityLimits',
        payload:newData
    })

}

export const setMarketLevelTabsList = (tabsList:string[])=>{
    store.dispatch({
        type:'setMarketLevelTabsList',
        payload:tabsList
    })
}
export const setOutletLevelTabsList = (tabsList:string[])=>{
    store.dispatch({
        type:'setOutletLevelTabsList',
        payload:tabsList
    })
}


export const updateCurrentTab = (value:string)=>{
    store.dispatch({
        type:'updateCurrentTab',
        payload:value
    })
}


export const updateInclusionData = (data:string[] , file:File | null)=>{
    store.dispatch({
        type:'updateInclusionData',
        payload:{
            file: file,
            list: [...data]
        }
    })
}


export const resetInclusionData = ()=>{
    store.dispatch({
        type:'resetInclusionData',
        payload:null
    })
}

export const updateExclusionData = (data:string[] , file:File | null)=>{
    store.dispatch({
        type:'updateExclusionData',
        payload:{
            file: file,
            list: [...data]
        }
    })
}


export const resetExclusionData = ()=>{
    store.dispatch({
        type:'resetExclusionData',
        payload:null
    })
}

export const setPercentageMaxAmount = (val:string)=>{
    store.dispatch({
        type:'setPercentageMaxAmount',
        payload:val
    })
}

// reset saved data not config data
export const resetAllData = ()=>{
    store.dispatch({
        type:'resetAllData',
        payload:null
    })
}

export const cacheSchemePlayGroundReduxState = (schemeId : string, schemeData : manageCouponInitialStateType)=>{
    store.dispatch({
        type:'cachePlayGroundScheme',
        payload: {
            schemeId,
            schemeData
        }
})}

export const postSchemeReduxState = (schemeId : string)=>{
    store.dispatch({
        type:'postScheme',
        payload: {
            schemeId
        }
})}

export const switchOffReduxState = ()=>{
    store.dispatch({
        type:'switchOffPlayGroundScheme',
        payload: {
        }
})}

export function updateSkipMarketSelection(val:boolean){
    store.dispatch({
        type:'updateSkipMarketSelection',
        payload:val
    })
}

export function cloneWholeScheme(schemeData:manageCouponInitialStateType){
    store.dispatch({
        type:'cloneWholeScheme',
        payload:schemeData
    })
}

export function reinitialiseCurrentTab(){
    store.dispatch({
        type : "reinitialiseCurrentTab",
    payload : {
        }
    })}

export function updateCouponTitle(value:string){
    store.dispatch({
        type: "updateCouponTitle",
        payload:value
    })
}

export function updatePlaygroundMode(value:boolean){
    store.dispatch({
        type: "updatePlayGroundMode",
        payload:value
    })
}

export function updateBannerActive(value:boolean){
    store.dispatch({
        type:'updateBannerActive',
        payload:value
    })
}

export const uploadBannerImage = (url:string)=>{
    store.dispatch({
        type: 'updateUploadBannerImage',
        payload:url
    })
}
export const uploadBannerPriority = (priority:string)=>{
    store.dispatch({
        type: 'updateUploadBannerPriority',
        payload:priority
    })
}


export function updateIsOverAndAbove(value:boolean){
    store.dispatch({
        type: "updateIsOverAndAbove",
        payload:value
    })
}

export function updateDeleteParent(value:boolean){
    store.dispatch({
        type: "updateDeleteParent",
        payload:value
    })
}

export function updateQuantityUnit(value:string){
    store.dispatch({
        type:'updateQuantityUnit',
        payload:value
    })
}
export function updateIsPeriodWelcome(value: boolean) {
    store.dispatch({
        type: 'updateIsPeriodWelcome',
        payload: value
    })
}

export function addCouponTimingSlab(data:any,id?:string){
    const {couponTimings} = store.getState().manageCoupons?.data?.recurrence;
    
    if(!id){
        store.dispatch({
            type:'updateCouponTimings',
            payload:[{...data,id:generateRandomId(),isSaved:false},...couponTimings]
        })
    }else{
        // we are updating
        const newData = couponTimings.map((item:any)=>{
            if(item.id == id) return data;
            else return item;
        })
        store.dispatch({
            type:'updateCouponTimings',
            payload:[...newData]
        })
    }
}

export function deleteCouponTimingSlab(id:string){
    const {couponTimings} = store.getState().manageCoupons?.data?.recurrence;

    const newData = couponTimings.filter((item:any)=>item.id !==id)
    store.dispatch({
        type:'updateCouponTimings',
        payload:newData
    })
}
export function updateInitialUsabilityFilled(value: boolean) {
    store.dispatch({
        type: 'updateInitialUsabilityFilled',
        payload: value
    })
}
export function updateIniUsability(value: boolean) {
    store.dispatch({
        type: 'updateIniUsability',
        payload: value
    })
}
export function updateIniUsabilityLimit(value: boolean) {
    store.dispatch({
        type: 'updateIniUsabilityLimit',
        payload: value
    })
}

export function saveInclusionFileUrl(value: string) {
    store.dispatch({
        type: 'saveInclusionFileUrl',
        payload: value
    })
}

export function saveExclusionFileUrl(value: string) {
    store.dispatch({
        type: 'saveExclusionFileUrl',
        payload: value
    })
}
